export default "__VITE_ASSET__DwTvj99c__"